import BG from "../../BG";
import Header from "../../Header";
import Body from "../../Body";
import Title from "../../Title";
import Text from "../../Text";
import Subtitle from "../../Subtitle";
import ButtonGroups from "../../ButtonGroups";
import Button from "../../Button";
import Image from "../../Image";
import setCurrentPage from "src/Utils/setCurrentPage";
import "./index.css";
import Label from "../../Label";

interface JourneyTwoProps {
  data: DataJourneyTwo;
}

const JourneyTwo = ({ data }: JourneyTwoProps) => {
  const {
    bgImage,
    title,
    subtitle,
    text,
    rightSideImage,
    next,
    back,
    imageCustomStyle,
    rightSideComponent,
    headerRightText,
    headerLeftImage,
    label,
    logoImage,
    logoImageStyle = {},
  } = data;

  const templateType = "journey-two-template";

  return (
    <BG bgImage={bgImage}>
      <Header
        onClickHome={() => setCurrentPage(1)}
        rightText={headerRightText}
        leftImage={headerLeftImage}
      />
      <Body>
        <div className="journey-two-container">
          <div className="journey-two-panel-left">
            <div>
              <Subtitle type={templateType} text={subtitle} />
              {logoImage && (
                <div style={logoImageStyle}>
                  <Image imagePath={logoImage} />
                </div>
              )}
              <div className="journey-two-title-and-label">
                {label && (
                  <div className="journey-two-label">
                    {label.map((item, index) => (
                      <Label
                        key={index}
                        iconPath={item.iconPath}
                        type={templateType}
                        text={item.text}
                      />
                    ))}
                  </div>
                )}
                <Title type={templateType} text={title} />
              </div>
              {text && <Text type={templateType} text={text} />}
            </div>
            <ButtonGroups>
              {back !== null && <Button {...back} />}
              {next !== null && <Button {...next} />}
            </ButtonGroups>
          </div>
          <div className="journey-two-panel-right">
            {rightSideImage && (
              <Image
                styleImage={imageCustomStyle ? imageCustomStyle : styles.image}
                imagePath={rightSideImage}
              />
            )}
            {rightSideComponent && rightSideComponent}
          </div>
        </div>
      </Body>
    </BG>
  );
};

const styles = {
  image: {
    position: "absolute" as React.CSSProperties["position"],
    top: 0,
    right: 0,
  },
};

export default JourneyTwo;
